﻿import React from 'react';
import CheckList from './CheckList';
import ButtonArea from './ButtonArea';
import TextArea from './TextArea';
import SavingsCard from './SavingsCard';

class ColumnItems extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            items: props.items || []
        };

    }




    render() {

        return (
            <div className="stack-w-margin-large">
                {
                    this.state.items.map((item, idx) => {
    
                        if (item.ItemType === 'GlobalGenericEmissionsConversionColumnItemHeadline') {
                            return <h3 className="toggle-group-headline" key={idx}>{item.Headline}</h3>
                        }
                        if (item.ItemType === 'GlobalGenericEmissionsConversionColumnItemTextArea') {
                            return <TextArea key={idx} textArea={item.TextArea} />
                        }
                        if (item.ItemType === 'GlobalGenericEmissionsConversionColumnItemChecklist') {
                            return <CheckList key={idx} listItems={item.CheckList} />
                        }
                        if (item.ItemType === 'GlobalGenericEmissionsConversionColumnItemButtonArea') {
                            return <ButtonArea key={idx} {...item} />
                        }
                        if (item.ItemType === 'GlobalGenericEmissionsConversionColumnItemCard') {
                            return <SavingsCard key={idx} {...item} isBio={this.props.isBio} />
                        }
                        return <p key={idx}>Not a valid itemType</p>
        
                    })
                }
            </div>
        )
    }
}

export default ColumnItems;